var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.class_obj,attrs:{"id":"main_layout"}},[_c('MainHeader'),_c('div',{attrs:{"id":"main_content"}},[_vm._t("default")],2),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }